import React from "react";

/* RockLink waffle — the nine-dot app-switcher mark.
   Default: RockLink's own palette (oranges, reds, warm greys), balanced so no
   row reads single-colour.
   mono: all dots take currentColor, so the parent button controls the ink —
   quiet grey at rest, warming to brand orange on hover/active (nav polish,
   16-Jul). */
const DOTS = [
  ["#f97316", "#ef4444", "#a8a29e"],
  ["#ef4444", "#fb923c", "#f97316"],
  ["#a8a29e", "#f97316", "#dc2626"],
];

export default function WaffleGlyph({ size = 17, mono = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {DOTS.map((row, r) =>
        row.map((color, c) => (
          <circle key={`${r}-${c}`} cx={5 + c * 7} cy={5 + r * 7} r="2.3" fill={mono ? "currentColor" : color} />
        ))
      )}
    </svg>
  );
}
